module.exports = __webpack_public_path__ + "static/media/Player_place_holder-09.a5ff62de.svg";